import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['iframe'];
  static values = {
    url: { type: String, default: '' },
  };

  connect() {
    this.element.hidden = null;
    this.iframeTarget.src = this.urlValue;
    this.iframeTarget.allowTransparency = true;
    this.iframeTarget.frameBorder = 0;
  }
}
